import { type ParameterInterface } from "@via/utils/interfaces.tsx";
import { type JSX } from "react";
import "./workflow-tooltip.css";

// This tooltip is specific to the "pipeline visualization" for now.
export const WorkflowTooltipWrap = ({ children }): JSX.Element => {
  return <div className="group">{children}</div>;
};

const getLabel = key => {
  switch (key) {
    case "identifier":
      return "Identifier:";
    case "process":
      return "Process:";
    case "name":
      return "Name:";
    case "qualifier":
      return "Qualifier:";
    case "fileType":
      return "File Type:";
    case "connect":
      return "";
    default:
      return `${key}:`;
  }
};

export const WorkflowTooltip = ({
  data,
}: {
  data: ParameterInterface;
}): JSX.Element => {
  if (!data) {
    return <></>;
  }
  return (
    <div className="workflow-tooltip z-[200]">
      {Object.entries(data).map(([key, value], i) => {
        if (key === "fileType" && data.qualifier === "val") {
          return null;
        }
        return (
          <p key={`${i}-${key}-${value}`}>
            <span className="font-semibold">{getLabel(key)} </span> {value}
          </p>
        );
      })}
    </div>
  );
};
